<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_tracking === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="ma-4">
          <div class="pa-3 pt-7">
            <v-divider/>
            <v-tabs grow show-arrows v-model="tab_menu" color="#8cc63e" v-if="loading_data === true">
              <v-tab  style="font-size: 18px" disabled>คำสั่งกำลังดำเนินการ</v-tab>
              <v-tab  style="font-size: 18px" disabled>เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-tabs grow show-arrows v-model="tab_menu" color="#8cc63e" v-else>
              <v-tab  style="font-size: 18px">คำสั่งกำลังดำเนินการ</v-tab>
              <v-tab  style="font-size: 18px">เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-divider/>
          </div>
          <div class="pa-3">
            <div v-if="loading_data === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0" hide-default-footer>
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.order_code }}</td>
                    <td>{{ dataDetail.item.receipt_code  || '-'}}</td>
                    <td>{{ dataDetail.item.name }}</td>
                    <td v-if="dataDetail.item.customer_paylater == 0">
                      <div v-if="dataDetail.item.status === 0">
                        <div style="color: #8cc63e">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 1">
                        <div v-if="dataDetail.item.payment_status === 0" style="color: black">{{ format_price(dataDetail.item.total) }}</div>
                         <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 1 || dataDetail.item.payment_type === 2" style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                        <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 0" style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                        <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 2" style="color: red">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 2">
                        <div style="color: #8cc63e">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 3">
                        <div style="color: red">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 4">
                        <div style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                    </td>
                    
                    <td v-if="dataDetail.item.customer_paylater == 1">
                      <div v-if="dataDetail.item.status === 0">
                        <div style="color: #8cc63e">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 1">
                        <div style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 2">
                        <div style="color: #8cc63e">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 3">
                        <div style="color: red">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 4">
                        <div style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 5">
                        <div v-if="dataDetail.item.payment_status === 0" style="color: #000">{{ format_price(dataDetail.item.total) }}</div>
                        <!-- <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 1 || dataDetail.item.payment_type === 2" style="color: #fdac39">ดำเนินการจัดสินค้า</div> -->
                        <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 0" style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                        <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 2" style="color: red">{{ format_price(dataDetail.item.total) }}</div>
                        <!-- <div style="color: #000">{{ format_price(dataDetail.item.total) }}</div> -->
                      </div>
                      <div v-else-if="dataDetail.item.status === 6">
                        <div style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                    </td>
                    <td>{{ dataDetail.item.created_at }}</td>
                    <td v-if="title_type === 0">
                      <div v-if="dataDetail.item.customer_paylater == 0">
                        <div v-if="dataDetail.item.status === 0">
                          <div style="color: #8cc63e">คำสั่งซื้อใหม่</div>
                        </div>
                        <div v-else-if="dataDetail.item.status === 1">
                          <div v-if="dataDetail.item.payment_status === 0" style="color: black">รอลูกค้าชำระเงิน</div>
                          <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 1 || dataDetail.item.payment_type === 2" style="color: #fdac39">ดำเนินการจัดสินค้า</div>
                          <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 0" style="color: #fdac39">รอตรวจสอบการชำระเงิน</div>
                          <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 2" style="color: red">การชำระเงินไม่ถูกต้อง</div>
                        </div>
                        <div v-else-if="dataDetail.item.status === 3">
                          <div style="color: red">การชำระเงินไม่ถูกต้อง</div>
                        </div>
                        <div v-else-if="dataDetail.item.status === 4">
                          <!-- <div style="color: #fdac39">เสนอดีลใหม่</div> -->
                          <div v-if="dataDetail.item.payment_status === 0" style="color: black">รอลูกค้าชำระเงิน</div>
                          <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 1 || dataDetail.item.payment_type === 2" style="color: #fdac39">ดำเนินการจัดสินค้า</div>
                          <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 0" style="color: #fdac39">รอตรวจสอบการชำระเงิน</div>
                          <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 2" style="color: red">การชำระเงินไม่ถูกต้อง</div>
                        </div>
                      </div>
                      <div v-if="dataDetail.item.customer_paylater == 1">
                        <div v-if="dataDetail.item.status === 0">
                          <div style="color: #8cc63e">คำสั่งซื้อใหม่</div>
                        </div>
                        <div v-else-if="dataDetail.item.status === 1">
                          <div style="color: #fdac39">ดำเนินการจัดสินค้า</div>
                        </div>
                        <div v-else-if="dataDetail.item.status === 4">
                          <div style="color: #fdac39">รอยืนยัน</div>
                        </div>
                        <div v-else-if="dataDetail.item.status === 5">
                          <div v-if="dataDetail.item.payment_status === 0" style="color: #000">ส่งของเสร็จแล้วรอลูกค้าจ่ายเงิน</div>
                          <!-- <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 1 || dataDetail.item.payment_type === 2" style="color: #fdac39">ดำเนินการจัดสินค้า</div> -->
                          <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 0" style="color: #fdac39">รอตรวจสอบการชำระเงิน</div>
                          <div v-else-if="dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 2" style="color: red">การชำระเงินไม่ถูกต้อง</div>
                          <!-- <div style="color: #fdac39">ส่งของเสร็จแล้วรอลูกค้าจ่ายเงิน</div> -->
                        </div>
                        <div v-else-if="dataDetail.item.status === 6">
                          <div style="color: #fdac39">ดำเนินการจัดสินค้า</div>
                        </div>
                      </div>
                    </td>
                    <td v-else>
                      <div v-if="dataDetail.item.delivery_type === 1 && dataDetail.item.status !== 3">รับหน้าร้าน</div>
                      <div v-else-if="dataDetail.item.delivery_type === 2 && dataDetail.item.status !== 3">แทร็กกิ้ง : {{ dataDetail.item.track_number }}</div>
                      <div v-else-if="dataDetail.item.delivery_type === 3 && dataDetail.item.status !== 3" style="color: grey">แทร็กกิ้ง : {{ dataDetail.item.track_number }}</div>
                      <div v-else-if="dataDetail.item.status === 3" style="color: red">ยกเลิก : {{ dataDetail.item.cancel_note }}</div>
                    </td>
                    <td class="pa-3" v-if="dataDetail.item.customer_paylater == 0">
                      <!-- New Order -->
                      <div v-if="dataDetail.item.status === 0">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <!-- Wait Payment -->
                      <div v-if="dataDetail.item.status === 1 && dataDetail.item.payment_status === 0">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <!-- Product Process -->
                      <div v-else-if="dataDetail.item.status === 1 && dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 1 || dataDetail.item.status === 1 && dataDetail.item.payment_type === 2">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn v-if="dataDetail.item.delivery_type === 1" small @click="tracking_shop(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.delivery_type === 2" small @click="tracking_chiangmai(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.delivery_type === 3" small @click="tracking_global(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <!-- Wait Process -->
                      <div v-else-if="dataDetail.item.status === 1 && dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 0">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <!-- Payment Incorrect -->
                      <div v-else-if="dataDetail.item.status === 1 && dataDetail.item.payment_status === 1 && dataDetail.item.slip_status === 2">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <!-- Success -->
                      <div v-else-if="dataDetail.item.status === 2">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <!-- Cancel -->
                      <div v-else-if="dataDetail.item.status === 3">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <!-- เสนอดีลใหม่ -->
                      <div v-else-if="dataDetail.item.status === 4">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                          <v-btn v-if="dataDetail.item.delivery_type === 1 && dataDetail.item.payment_status == 1 && dataDetail.item.slip_status == 1" small @click="tracking_shop(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                            ส่งแล้ว
                          </v-btn>
                          <v-btn v-else-if="dataDetail.item.delivery_type === 2 && dataDetail.item.payment_status == 1 && dataDetail.item.slip_status == 1" small @click="tracking_chiangmai(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                            ส่งแล้ว
                          </v-btn>
                          <v-btn v-else-if="dataDetail.item.delivery_type === 3 && dataDetail.item.payment_status == 1 && dataDetail.item.slip_status == 1" small @click="tracking_global(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                            ส่งแล้ว
                          </v-btn>
                          <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                            <v-icon>mdi-refresh</v-icon>
                          </v-btn>
                      </div>
                    </td>
                    <td class="pa-3" v-if="dataDetail.item.customer_paylater == 1">
                      <div v-if="dataDetail.item.status === 0">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="dataDetail.item.status === 1">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn v-if="dataDetail.item.delivery_type === 1" small @click="tracking_shop(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.delivery_type === 2" small @click="tracking_chiangmai(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.delivery_type === 3" small @click="tracking_global(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="dataDetail.item.status === 2">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 4">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 5">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 6">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn v-if="dataDetail.item.delivery_type === 1" small @click="tracking_shop(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.delivery_type === 2" small @click="tracking_chiangmai(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.delivery_type === 3" small @click="tracking_global(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn small @click="clear_reset_lot_modal(dataDetail.item.id)" height="42" class="grad-cancel-bg white--text mr-1 mb-1" title="รีเซ็ต">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td class="pa-3">
                      <v-btn small height="42" class="grad-main-bg white--text ml-1 mb-1" title="พิมพ์ใบเสร็จ" @click="print_send_order(dataDetail.item.order_code, dataDetail.item.delivery_type)">
                        <v-icon>mdi-printer</v-icon>พิมพ์
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-pagination v-if="data_list.length !== 0" class="mt-4 mb-4" v-model="num_pages" :length="pages" :total-visible="7" circle color="#8cc63e"></v-pagination>
            </div>
          </div>
        </div>
        <!-- tracking_shop -->
        <v-dialog v-model="tracking_save" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="save_data">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยืนยันการส่งสินค้า
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  คุณจัดสินค้าให้ลูกค้าเรียบร้อยแล้ว แจ้งลูกค้ามารับได้เลยใช่ไหม ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  จัดสินค้าแล้ว
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- tracking_chiangmai -->
        <v-dialog v-model="tracking_confirm" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="save_data_chiangmai">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยืนยันการส่งสินค้า
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  รถสินค้าของคุณ ได้ทำการออกไปจัดส่งสินค้าให้ลูกค้าเรียบร้อยแล้ว ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  ส่งสินค้าแล้ว
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- tracking_global -->
        <v-dialog v-model="tracking_success" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="wait_for_save">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  เพิ่มหมายเลขแทร๊กกิ้ง
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  <v-text-field color="#86bc3a" clearable class="rounded-pill" type="text" label="กรุณากรอกหมายเลขแทร็กกิ้ง" :rules="[v => !!v || 'กรุณากรอกหมายเลขแทร็กกิ้ง']" prepend-inner-icon="mdi-truck-minus-outline" v-model="modal_track.tracking_number" hide-details="auto" maxlength="20" outlined></v-text-field>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  ยืนยันหมายเลขแทร็กกิ้ง
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- ยืนยันการรีเซ็ต -->
        <v-dialog v-model="clear_reset_lot" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form @submit.prevent="save_clear_reset_lot">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยืนยันการเคลียร์ล็อตสินค้าใหม่
                </v-card-title>
                <v-btn icon class="ma-4" @click="clear_reset_lot = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  คุณต้องการเคลียร์ล็อตสินค้าใหม่หรือไม่ ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-cancel-bg white--text mr-3" type="submit" style="font-size: 18px">
                  เคลียร์ล็อตสินค้าใหม่
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div style="text-align: center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_customer_main",
  data() {
    return {
      loading_page: false,
      loading_data: true,
      tracking_success: false,
      tracking_save: false,
      tracking_confirm: false,
      alert_success: false,
      alert_tracking: false,
      clear_reset_lot: false,
      clear_reset_lot_id: null,
      overlay: false,
      title_type: 1,
      modal_track: {
        tracking_id: null,
        tracking_number: null,
      },
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [],
      datalist: [
        {
          id: 1,
          order_no: 'Or65/00001',
          username: 'สุธิชา องค์วงศ์สกุล',
          total: '12,000.00',
          order_date: '12/12/2565',
          note_track: 'สาขาเมญา',
          status: 0,
          print_status: 0,
          pay_status: 0,
          track_status: 0,
        },
        {
          id: 2,
          order_no: 'Or65/00003',
          username: 'สุธิชา องค์วงศ์สกุล',
          total: '36,000.00',
          order_date: '07/12/2565',
          note_track: 'นิมมาน',
          status: 1,
          print_status: 1,
          pay_status: 1,
          track_status: 0,
        },
        {
          id: 3,
          order_no: 'Or65/00023',
          username: 'สุธิชา องค์วงศ์สกุล',
          total: '36,000.00',
          order_date: '30/12/2565',
          note_track: 'KWQ100023987',
          status: 1,
          print_status: 1,
          pay_status: 1,
          track_status: 1,
        },
        {
          id: 4,
          order_no: 'Or65/00023',
          username: 'สุธิชา องค์วงศ์สกุล',
          total: '36,000.00',
          order_date: '30/12/2565',
          note_track: 'ลูกค้ายกเลิก',
          status: 2,
          print_status: 2,
          pay_status: 2,
          track_status: 2,
        },
        {
          id: 5,
          order_no: 'Or65/00023',
          username: 'สุธิชา องค์วงศ์สกุล',
          total: '36,000.00',
          order_date: '30/12/2565',
          note_track: 'KWQ100023987',
          status: 1,
          print_status: 1,
          pay_status: 1,
          track_status: 2,
        },
      ],
      data_list: [],
      tab_menu: 0,

      pages: 1,
      num_pages: 1,
      size: 10,
      search: "",
      searchTimer: null
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    async page(type) {
      this.title_type = type
      if (this.title_type === 0) {
        this.headers = [
          {
            text: 'รหัสคำสั่งซื้อ',
            value: 'order_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'เลขใบกำกับภาษี',
            value: 'receipt_code',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ลูกค้า',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ยอดรวม',
            value: 'total',
            fixed: true,
            width: '200px',
          },
          {
            text: 'วันที่สั่งซื้อ',
            value: 'created_at',
            fixed: true,
            width: '150px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '250px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'พิมพ์',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
        ]
       await this.get_data()
      }
      if (this.title_type === 1) {
        this.headers = [
          {
            text: 'รหัสคำสั่งซื้อ',
            value: 'order_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'เลขใบกำกับภาษี',
            value: 'receipt_code',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ลูกค้า',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ยอดรวม',
            value: 'total',
            fixed: true,
            width: '200px',
          },
          {
            text: 'วันที่สั่งซื้อ',
            value: 'created_at',
            fixed: true,
            width: '150px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '250px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '200px',
          },
          {
            text: 'พิมพ์',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
        ]
       await this.get_data()
      }
    },
   async get_data() {
      this.loading_data = true
     await HTTP.post(`wholesales/all?page=${this.num_pages}&size=${this.size}&search=${this.search}`, {
        status: this.title_type,
        user_type: 1,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_data = false
          this.data_list = res.data.object
          this.num_pages = parseInt(res.data.page);
          this.pages = parseInt(res.data.count_pages);
          const num_datalist = this.data_list.length
          for (let index = 0; index < num_datalist; index++) {
            this.data_list[index]['total'] =  this.data_list[index]['delivery_type'] != 3 ? this.data_list[index]['total_notdelivery'] : this.data_list[index]['total']
            
          }
        }
      })
    },
    tracking_global(id,count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.tracking_success = true
        this.modal_track.tracking_id = id
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: 'สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.tracking_success = false
        })
      }

    },
    tracking_shop(id,count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.tracking_save = true
        this.modal_track.tracking_id = id
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: 'สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.tracking_save = false
        })
      }
    },
    tracking_chiangmai(id,count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.tracking_confirm = true
        this.modal_track.tracking_id = id
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: 'สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.tracking_confirm = false
        })
      }
    },
    clear_reset_lot_modal(id){
      this.clear_reset_lot = true
      this.clear_reset_lot_id = id
    },
    save_clear_reset_lot(){
      this.overlay = true
      this.clear_reset_lot = false
      HTTP.post('wholesales/recreate', {
        order_wholesale_id: this.clear_reset_lot_id,
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.clear_reset_lot_id = null
          this.alert_clear_reset_lot_success = true
          setTimeout(() => this.alert_clear_reset_lot_success = false, 1000)
          this.get_data()
        }
      })
    },
    wait_for_save() {
      if (this.$refs.update.validate()) {
        HTTP.post('wholesales/trackingnumber', {
          order_id: this.modal_track.tracking_id,
          tracking_number: this.modal_track.tracking_number,
          user_id: this.$store.state.userDetail.id,
          user_name: this.$store.state.userDetail.name,
        }).then((res) => {
          if (res.data.success === true) {
            this.tracking_success = false
            this.alert_success = true
            setTimeout(() => this.alert_success = false, 1000)
            this.get_data()
          }
          else {
            Swal.fire({
              text: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.tracking_success = false
            })
          }
        })
      }
    },
    save_data() {
      this.overlay = true
      this.tracking_save = false
      HTTP.post('wholesales/trackingnumber', {
        order_id: this.modal_track.tracking_id,
        tracking_number: 'รับหน้าร้าน',
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          let timerInterval
          Swal.fire({
            title: 'เสร็จสิ้น',
            text: 'แก้ไขข้อมูลเรียบร้อย',
            icon: 'success',
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading()
              timerInterval = setInterval(() => { }, 100)
            },
            willClose: () => {
              clearInterval(timerInterval)
              this.overlay = false
              this.tracking_save = false
              this.alert_success = true
              setTimeout(() => this.alert_success = false, 1000)
              this.get_data()
            }
          })
        } else {
          Swal.fire({
            text: res.data.message,
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.overlay = false
            this.tracking_save = false
          })
        }
      })
    },
    save_data_chiangmai() {
      this.overlay = true
      this.tracking_confirm = false
      HTTP.post('wholesales/trackingnumber', {
        order_id: this.modal_track.tracking_id,
        tracking_number: 'จัดส่งในเชียงใหม่',
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          let timerInterval
          Swal.fire({
            title: 'เสร็จสิ้น',
            text: 'แก้ไขข้อมูลเรียบร้อย',
            icon: 'success',
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading()
              timerInterval = setInterval(() => { }, 100)
            },
            willClose: () => {
              clearInterval(timerInterval)
              this.overlay = false
              this.tracking_confirm = false
              this.tracking_save = false
              this.alert_success = true
              setTimeout(() => this.alert_success = false, 1000)
              this.get_data()
            }
          })
        } else {
          Swal.fire({
            text: res.data.message,
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.overlay = false
            this.tracking_confirm = false
            this.tracking_save = false
          })
        }
      })
    },
    get_detail(id) {
      this.$router.push('/sell/ordercustomerdetail/' + id)
    },
    get_detail_identify(id) {
      this.$router.push('/sell/orderidentify/' + id)
    },
    get_incorrect_detail(id) {
      this.$router.push('/sell/paycustomerincorrect/' + id)
    },
    get_confirm_detail(id) {
      this.$router.push('/sell/confirmcustomerdetail/' + id)
    },
    cancel_detail(id) {
      this.$router.push('/sell/payincorrect/' + id)
    },
    close_modal() {
      this.tracking_success = false
      this.tracking_save = false
      this.tracking_confirm = false
      this.modal_track.tracking_number = ''
    },
    change_trackStatus(id) {
      Swal.fire({
        title: 'คุณต้องเปลี่ยนสถานะหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('', {
            id: id
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_tracking = true
              setTimeout(() => this.alert_tracking = false,2000)
            }
          })
        }
      })
    },
    print_send_order(order_code, delivery_type) {
      if (delivery_type !== 1) {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/' + order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipwholesale/' + order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/envelopewholesale/' + order_code, '_blank')
      } else {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/' + order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipwholesale/' + order_code, '_blank')
      }
    },
  },
  mounted() {
    this.page(0)
  },
  watch:{
    tab_menu(){
      this.page(this.tab_menu)
    },
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.get_data();
      }, 500);
    },
    num_pages() {
      this.get_data()
    }
  }
}
</script>

<style scoped>

</style>
